export interface IAzureResource {
  subcategory: string;
  totalCost: number;
  azurePlanId: string; // Refers to Azure Plan Id, but is considered as any other Microsoft "Subscription" Id
}

export default class AzureResource {
  private subcategory: string;
  private totalCost: number;
  private azurePlanId: string;

  constructor(dto: IAzureResource) {
    Object.assign(this, dto);
  }

  get getSubcategory(): string {
    return this.subcategory;
  }

  set setSubcategory(subcategory: string) {
    this.subcategory = subcategory;
  }

  get getTotalCost(): number {
    return this.totalCost;
  }

  set setTotalCost(totalCost: number) {
    this.totalCost = totalCost;
  }

  get getAzurePlanId(): string {
    return this.azurePlanId;
  }

  set setAzurePlanId(azurePlanId: string) {
    this.azurePlanId = azurePlanId;
  }
}
